var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
import { round } from '../../../utils/helper/lodash_replacements';
export class MultipleChoiceScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        // Formel:
        //   2 * Summe( Anteil der Falschantworten an den verbliebenen Antwortoptionen * Anteil an noch aktiven Optionen am gesamten )
        const num_options = this.question.options.length;
        const num_correct = this.question.choiceInfo.optionsToBeSelected.length;
        if (num_options === num_correct)
            return 0.1; // all options are correct
        const num_false = num_options - num_correct;
        const factor = 2;
        let points = 0;
        for (let i = 0; i < num_correct; i++) {
            const num_remaining = num_options - i;
            const share1 = num_false / num_remaining;
            const share2 = (num_options - i) / num_options;
            points += share1 * share2;
        }
        points *= factor;
        return round(points, 1);
    }
    get reachedPoints() {
        // Formel: Anzahl an korrekt geklickten Optionen * maxPoints
        let reachedPoints = round(this.question.questionInfo.maxPoints *
            (this.question.choiceEval.correctlySelectedOptions.length / this.question.choiceInfo.optionsToBeSelected.length), 1);
        if (this.question.choiceAttempts.numberOfFailedAttempts > 0 && this.question.choiceInfo.numberOfFalseOptions > 0) {
            reachedPoints -= this.question.choiceAttempts.numberOfFailedAttempts / this.question.choiceInfo.numberOfFalseOptions;
        }
        return Math.max(0, reachedPoints);
    }
    get progressiveReachablePoints() {
        // Formel: Anzahl an korrekt geklickten Optionen * maxPoints
        return round(this.question.questionInfo.maxPoints *
            (Math.min(this.question.choiceEval.selectedOptions.length, this.question.choiceInfo.optionsToBeSelected.length) /
                this.question.choiceInfo.optionsToBeSelected.length), 1);
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        if (this.question.answer.completeDate)
            return false;
        if (this.question.answeringState.currentAnswerState !== QuestionAnswerState.Answering)
            return false;
        return this.question.choiceEval.isComplete;
    }
    get legacyEvalText() {
        return this.question.multipleChoiceStore.multipleChoiceLegacy.evaltext;
    }
    set legacyEvalText(t) {
        this.question.multipleChoiceStore.multipleChoiceLegacy.evaltext = t;
    }
}
__decorate([
    override
], MultipleChoiceScore.prototype, "maxPoints", null);
__decorate([
    override
], MultipleChoiceScore.prototype, "reachedPoints", null);
__decorate([
    override
], MultipleChoiceScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], MultipleChoiceScore.prototype, "shouldSetCompletedTimestamp", null);
